import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 220,
    marginTop: "10px",
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },

  rootFirstSelect: {
    padding: "4px 0px",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

const options = [
  {
    label: "Taxable",
    value: "TAXABLE",
  },
  {
    label: "Zero",
    value: "ZERO",
  },
  {
    label: "Exempt",
    value: "EXEMPT",
  },
  {
    label: "Taxable",
    value: "TAXABLE",
  },
  {
    label: "Zero",
    value: "ZERO",
  },
  {
    label: "Exempt",
    value: "EXEMPT",
  },
  {
    label: "Taxable",
    value: "TAXABLE",
  },
  {
    label: "Zero",
    value: "ZERO",
  },
  {
    label: "Exempt",
    value: "EXEMPT",
  },
];

const DataFormater = (number) => {
  if(number>0){
  if (number > 1000000000) {
    return (number / 1000000000).toString() + "B";
  } else if (number > 1000000) {
    return (number / 1000000).toString() + "M";
  } else if (number > 1000) {
    return (number / 1000).toString() + "K";
  } else {
    if(number < 0){
      let spllitedNumber = (number).toString().split('-');
      let modifiedNuber = +(spllitedNumber[1]);
      if(modifiedNuber  > 1000000000){
        console.log()
        return -(modifiedNuber / 1000000000).toString() + "B";
      }else if(modifiedNuber > 1000000){
        return -(modifiedNuber / 1000000).toString() + "M";
      }else if(modifiedNuber > 1000){
        return -(modifiedNuber / 1000).toString() + "K";
      }
    }else{
      return number.toString();
    }
    
  }
}else{
  if (number < -1000000000) {
    return (number / 1000000000).toString() + "B";
  } else if (number < -1000000) {
    return (number / 1000000).toString() + "M";
  } else if (number < -1000) {
    return (number / 1000).toString() + "K";
  } else {
    return number.toString();
  }
}
};
export const PeriodMessage =
  "Please select only four Return Period, when you are not selecting the Periodicity";

  function isDecimal(num) {
    return (num % 1);
 }
 function currenyFormater(inputNumber) {
  if(isDecimal(inputNumber)){
    if(typeof(inputNumber) == 'number'){
      let numberString = inputNumber.toFixed(2);
      let numberWithCommas = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return numberWithCommas;
    }else{
      let numberString = Number(inputNumber).toFixed(2);
      let numberWithCommas = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return numberWithCommas;
    }
   
  }else{
    if(typeof(inputNumber) == 'number'){
      let numberString = inputNumber.toString();
      let numberWithCommas = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return numberWithCommas;
    }else{
      let numberString = inputNumber;
      let numberWithCommas = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return numberWithCommas;
    }
    
  }
  
}
// const currenyFormater = (value) => {
//   if(isDecimal(value)){
//     value = value.toFixed(2);
//     let spllitedValue = value.split('.');
//     value = Math.round(spllitedValue[0]);
//     value = value.toString();
//     value = value.split(/(?=(?:...)*$)/);
//     value = value.join(",");
//     let valueToReturn = value + '.' + spllitedValue[1]
//    value = valueToReturn;
//    let 
//    console.log('negative value',value)
//    // console.log('vvd',value?.toFixed(2))
//     return value
//   }else{
//     value = Math.round(value);
//     value = value.toString();
//     value = value.split(/(?=(?:...)*$)/);
//     value = value.join(",");
//     console.log('positive value',value)
//     return value;
//   }

// };

const graphStyle = {
  fontSize: ".5em",
  textAnchor: "end",
  fontWeight: "bold",
};
export {
  useStyles,
  MenuProps,
  options,
  DataFormater,
  currenyFormater,
  graphStyle,
};
